export default __webpack_public_path__ + "static/media/Shemite Mercenary Armbands.19190769.jpg";